<template>
  <v-container class="text-center">
    <h1>Get started absolutely free.</h1>
    <div class="mb-10">
      Already have an account? <router-link :to="{name: 'auth.signin'}">Sign In!</router-link>
    </div>

    <v-form
      ref="form"
      lazy-validation
      @submit="submit"
    >
      <v-text-field
        label="Full Name"
        required
        outlined
        :disabled="loading"
        v-model="fullName"
        :error-messages="fullNameErrors"
      ></v-text-field>

      <v-text-field
        label="E-mail"
        type="email"
        required
        outlined
        :disabled="loading"
        v-model="email"
        :error-messages="emailErrors"
      ></v-text-field>

      <v-text-field
        :append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
        :type="showPass ? 'text' : 'password'"
        label="Password"
        required
        outlined
        :disabled="loading"
        @click:append="showPass = !showPass"
        v-model="pass"
        :error-messages="passErrors"
      ></v-text-field>

      <v-btn color="primary"
             class="w-100 sh-green mb-5"
             x-large
             :loading="loading"
             @click="submit">
        Sign Up
      </v-btn>

      <router-link to="/">Forgot password?</router-link>
    </v-form>
  </v-container>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required, maxLength, minLength, email } from 'vuelidate/lib/validators'
import { mapActions } from 'vuex'

export default {
  name: 'SignUp',

  mixins: [validationMixin],
  validations: {
    fullName: { required, maxLength: maxLength(64) },
    email: { required, email },
    pass: { required, minLength: minLength(6), maxLength: maxLength(16) }
  },
  computed: {
    fullNameErrors () {
      const errors = []
      if (!this.$v.fullName.$dirty) return errors
      !this.$v.fullName.maxLength && errors.push('Full name must be less than 64 characters long')
      !this.$v.fullName.required && errors.push('Full name is required')
      return errors
    },
    emailErrors () {
      const errors = []
      if (!this.$v.email.$dirty) return errors
      !this.$v.email.email && errors.push('Must be valid e-mail')
      !this.$v.email.required && errors.push('E-mail is required')
      this.invalidEmail && errors.push('Email already exists')
      return errors
    },
    passErrors () {
      const errors = []
      if (!this.$v.pass.$dirty) return errors
      !this.$v.pass.minLength && errors.push('Password must be more than 6 characters long')
      !this.$v.pass.maxLength && errors.push('Password must be less than 16 characters long')
      !this.$v.pass.required && errors.push('Password is required')
      return errors
    }
  },

  data: () => ({
    showPass: false,
    fullName: '',
    email: '',
    pass: '',
    loading: false,
    invalidEmail: false
  }),
  methods: {
    ...mapActions({
      register: 'auth/REGISTER'
    }),
    submit () {
      this.invalidEmail = false
      this.loading = true
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.$api.auth.signUp({
          full_name: this.fullName,
          email: this.email,
          password: this.pass
        }).then(({ data }) => {
          this.register(this.email)
          this.$router.push({ name: 'auth.reg-verify' })
        }).catch(() => {
          this.invalidEmail = true
        }).finally(() => {
          this.loading = false
        })
      } else {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped lang="scss">
</style>
